import { Create } from 'react-admin'

import CollectionForm from './CollectionForm'

const CollectionCreate = props => (
  <Create redirect="list" {...props}>
    <CollectionForm />
  </Create>
)

export default CollectionCreate
